export const bundlingList = (state) => {
    let temps = state.lists
    let lists = []

    if (Array.isArray(temps) && temps.length) {
        temps.forEach(temp => {
            lists.push({
                id: temp.id,
                label: temp.name
            })        
        });
    }

    return lists
}
